import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { WaitingRoom } from '../../atoms/illustrations/WaitingRoom'
import { Title } from '../../atoms/title/Title'
import { BodyTextSize, TitleSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'

const Container = styled.View(({ theme }) => ({
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  paddingTop: theme.spacing['16px'],
  paddingBottom: theme.breakpoints.isMobileSized ? '120px' : undefined,
  flexGrow: 1,
}))

const CenteredContainer = styled.View(({ theme }) => ({
  gap: theme.breakpoints.isMobileSized ? theme.spacing['16px'] : theme.spacing['72px'],
  alignItems: 'center',
  justifyContent: theme.breakpoints.isMobileSized ? undefined : 'center',
  width: '100%',
}))

const TextContainer = styled.View(({ theme }) => ({
  gap: theme.breakpoints.isMobileSized ? theme.spacing['4px'] : theme.spacing['8px'],
  alignItems: 'center',
  paddingLeft: theme.spacing['16px'],
  paddingRight: theme.spacing['16px'],
  maxWidth: '800px',
}))

export type ZoomWaitingRoomProps = {
  participantName: string
  hideRecordingWarning?: boolean
}

export const ZoomWaitingRoom: FunctionComponent<ZoomWaitingRoomProps> = ({
  participantName,
  hideRecordingWarning = false,
}) => {
  const {
    colors,
    breakpoints: { isMobileSized },
  } = useTheme() as ThemeType
  const subText = (
    <FormattedMessage
      defaultMessage='Recording may begin at the onset of your session. You will be asked whether you consent to proceed with recording the entire session and may revoke your consent at any time. If consent is revoked, all of the recording will be deleted.'
      description='Subtext about recording consent'
    />
  )
  return (
    <Container>
      <CenteredContainer>
        <WaitingRoom />
        <TextContainer>
          <Title
            size={isMobileSized ? TitleSize.XSMALL : TitleSize.LARGE}
            text={
              <FormattedMessage
                defaultMessage='{participantName} will join the session shortly'
                description='Subtext about participant joining shortly'
                values={{ participantName }}
              />
            }
          />
          {!hideRecordingWarning &&
            (isMobileSized ? (
              <BodyText size={BodyTextSize.SMALL} color={colors.textSecondary} text={subText} />
            ) : (
              <Title size={TitleSize.MEDIUM} color={colors.textSecondary} text={subText} />
            ))}
        </TextContainer>
      </CenteredContainer>
    </Container>
  )
}
